import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaSearch,
  FaEye,
  FaEdit,
  FaTrash,
  FaChevronLeft,
  FaChevronRight,
  FaBalanceScale,
  FaPlus,
} from "react-icons/fa";

const RebalancePage = () => {
  const [data, setData] = useState([]);
  const [filteredType, setFilteredType] = useState("all");
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({ current_page: 1, last_page: 1, total: 0 });
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/rebalance?page=${page}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await res.json();
      setData(result.data);
      setMeta({
        current_page: result.meta.current_page,
        last_page: result.meta.last_page,
        total: result.meta.total,
      });
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const formatDate = (iso) => new Date(iso).toISOString().split("T")[0];

  const handleApprove = async (id) => {
    if (!window.confirm("Yakin akan approve data ini?")) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/rebalance/approve/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.ok) {
        alert("Berhasil approve");
        fetchData();
      } else alert("Gagal approve");
    } catch (err) {
      console.error(err);
      alert("Error saat approve");
    }
  };

  const filteredData = data
    .filter((i) => (filteredType === "all" ? true : i.type === filteredType))
    .filter((i) => i.objective.toLowerCase().includes(searchTerm.toLowerCase()));

  const canPrevious = page > 1;
  const canNext = page < meta.last_page;

  return (
    <div className="p-5 min-h-screen flex flex-col space-y-6">
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-100">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-blue-100 rounded-2xl shadow-inner">
            <FaBalanceScale className="text-blue-600" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-800">Rebalance</h1>
            <p className="text-gray-500 text-sm">
              Menampilkan perpindahan stok antar outlet untuk monitoring dan approval.
            </p>
          </div>
        </div>
        <nav aria-label="Breadcrumb" className="mt-3 text-gray-500 text-sm">
          <ol className="flex items-center space-x-2">
            <li>Inventory</li>
            <li>/</li>
            <li className="text-gray-400">Rebalance</li>
          </ol>
        </nav>
      </div>

      <div className="bg-white shadow-xl border border-gray-100 rounded-2xl p-6 space-y-6">
        <div className="flex flex-col gap-3 md:flex-row md:justify-between md:items-center">
          <h2 className="text-lg font-semibold text-gray-800">Daftar Rebalance</h2>
          <button
            onClick={() => navigate("/rebalance/create")}
            className="h-11 bg-yellow-500 hover:bg-yellow-600 text-white px-4 rounded-xl font-medium transition inline-flex items-center gap-2"
          >
            <FaPlus />
            Do Rebalance
          </button>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex flex-wrap gap-2">
            {["all", "in", "out"].map((t) => (
              <button
                key={t}
                onClick={() => setFilteredType(t)}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition ${
                  filteredType === t
                    ? "bg-blue-100 text-blue-700 border-blue-200"
                    : "text-gray-700 bg-white hover:bg-gray-100 border-gray-300"
                }`}
              >
                {t.charAt(0).toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>

          <div className="relative w-full md:w-1/3">
            <input
              type="text"
              placeholder="Cari berdasarkan objective..."
              className="h-11 w-full px-4 pl-10 rounded-xl border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <FaSearch className="absolute left-3 top-3.5 text-gray-400" />
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm">
          <table className="min-w-full bg-white text-sm text-left">
            <thead className="bg-blue-50 text-gray-700">
            <tr>
                {/* <th className="p-3">Obat</th> */}
                <th className="px-4 py-3 font-semibold">ED</th>
                <th className="px-4 py-3 font-semibold">Stock</th>
                <th className="px-4 py-3 font-semibold">Type</th>
                <th className="px-4 py-3 font-semibold">Objective</th>
                <th className="px-4 py-3 font-semibold">Approved</th>
                <th className="px-4 py-3 font-semibold">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center p-6 text-gray-500">Loading...</td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id} className="border-b border-gray-100 hover:bg-gray-50">
                    {/* <td className="p-3">{item.obat_name}</td> */}
                    <td className="px-4 py-3">{formatDate(item.created_at)}</td>
                    <td className="px-4 py-3">{item.stock}</td>
                    <td className="px-4 py-3 capitalize">
                      <span
                        className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${
                          item.type === "in"
                            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
                            : "bg-amber-50 text-amber-700 border-amber-100"
                        }`}
                      >
                        {item.type}
                      </span>
                    </td>
                    <td className="px-4 py-3 capitalize">{item.objective}</td>
                    <td className="px-4 py-3">
                      <input
                        type="checkbox"
                        checked={item.approved}
                        onChange={() => {
                          if (!item.approved && role === "owner") handleApprove(item.id);
                        }}
                        disabled={item.approved || role !== "owner"}
                        className="w-4 h-4 text-green-600 rounded cursor-pointer disabled:opacity-50"
                        title={
                          item.approved
                            ? "Sudah di-approve"
                            : role !== "owner"
                            ? "Hanya owner yang bisa approve"
                            : "Klik untuk approve"
                        }
                      />
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                    <button
                        onClick={() => navigate(`/rebalance/detail/${item.id}`)}
                        title="View"
                        className="inline-flex items-center justify-center w-8 h-8 rounded-md text-blue-600 hover:bg-blue-50 hover:text-blue-700 transition"
                      >
                        <FaEye />
                      </button>



                      <button
                        onClick={() => alert("Edit form")}
                        disabled={item.approved}
                        title="Edit"
                        className={`inline-flex items-center justify-center w-8 h-8 rounded-md transition ${
                          item.approved ? "text-gray-400 cursor-not-allowed" : "text-amber-500 hover:bg-amber-50 hover:text-amber-600"
                        }`}
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => alert("Delete not implemented")}
                        disabled={item.approved}
                        title="Delete"
                        className={`inline-flex items-center justify-center w-8 h-8 rounded-md transition ${
                          item.approved ? "text-gray-400 cursor-not-allowed" : "text-red-500 hover:bg-red-50 hover:text-red-600"
                        }`}
                      >
                        <FaTrash />
                      </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center p-6 text-gray-500">No data found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex flex-col md:flex-row justify-between items-center mt-6 gap-3">
          <p className="text-sm text-gray-500">
            Menampilkan {filteredData.length} data dari total {meta.total}
          </p>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => canPrevious && setPage(page - 1)}
              disabled={!canPrevious}
              className="flex items-center px-3 py-2 text-sm bg-blue-50 border border-blue-100 hover:bg-blue-100 text-gray-700 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FaChevronLeft className="mr-1" /> Sebelumnya
            </button>
            <span className="text-sm text-gray-600">
              Halaman <strong>{meta.current_page}</strong> dari <strong>{meta.last_page}</strong>
            </span>
            <button
              onClick={() => canNext && setPage(page + 1)}
              disabled={!canNext}
              className="flex items-center px-3 py-2 text-sm bg-blue-50 border border-blue-100 hover:bg-blue-100 text-gray-700 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Berikutnya <FaChevronRight className="ml-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RebalancePage;
